import { TooltipWrapper } from '../adminComponents';
import { ManualIcon } from '../assets';
import { Icon } from '../styles';

export const ManualIconTooltip = ({ tooltip }: { tooltip: string }) => {
  return (
    <TooltipWrapper tooltip={tooltip} $width="22px" tooltipWidthSM="250px">
      <Icon $size={22}>
        <ManualIcon />
      </Icon>
    </TooltipWrapper>
  );
};
